import React from "react"
import {Link} from "gatsby"

import Img from "gatsby-image"

//import loadable from '@loadable/component'



const CarouselCard = ({ data, img, title, description, price, linkLabel, linkUrl, component, urlCategory, hidePrice, ignoreLowerCase}) => {

    //component prop is used to differentiate where I want to use this component


    // return <CardImage title={img} title={title} description={description} type={'normal'}  />

 
    const vat   = 1.2;
    let priceWithVat = Math.round(price * vat*100)/100
    
    return (
    <Link to={linkUrl} className="carousel-card ">
    <div className=" uk-card ">
        <div className="uk-card-media-top card-media-wrapper carousel-image">
            {typeof img === "string"?<img src={img} alt={img}></img>:<Img fluid={img} src={img} alt={title}></Img>}
           
        </div>
        <div 
        // className="carousel-card-body uk-card-body uk-padding-remove"
        className={`${component==='products' ? 'carousel-card-body-products uk-card-body uk-padding-remove' : component==='news'? 'carousel-card-body-news uk-card-body uk-padding-remove' : ''}`}>
            <div  className='card-title'>{ignoreLowerCase? title : title.toLowerCase()}</div>
            <div className="card-description">{description.slice(0,50)}</div>
           
            
            {price!==null && price!==undefined && ! hidePrice? 
                <div className="card-price">
                
                    <div>{`£${priceWithVat}`} <span className='vat'>inc. VAT</span></div>
                </div>
                :""
            }


            <div >
                <Link to={linkUrl} className="card-link">
                    {linkLabel} 
                </Link>
            </div>
            
        </div>
    </div>
        
        
        
    </Link>
    )  
}

export default CarouselCard